import { autoUpdate, flip, offset, shift, useFloating } from '@floating-ui/vue';
import type { Ref } from 'vue';

/**
 * Places a datepicker panel below its reference and keeps it fully on screen: it flips above
 * when there is more room there and otherwise shifts into the viewport, even over the reference.
 * Fixed positioning escapes clipping containers without a teleport, so modal focus traps still
 * let the panel's inputs take focus.
 */
export function useDatepickerFloating(
  reference: Readonly<Ref<HTMLElement | null>>,
  floating: Readonly<Ref<HTMLElement | null>>,
) {
  const { floatingStyles } = useFloating(reference, floating, {
    placement: 'bottom-start',
    strategy: 'fixed',
    middleware: [offset(4), flip({ padding: 8 }), shift({ padding: 8, crossAxis: true })],
    whileElementsMounted: autoUpdate,
  });
  return floatingStyles;
}
